<div class="language-selector" (clickOutside)="close()" data-wg-notranslate>
  <button
    type="button"
    class="selector-button"
    (click)="toggleDropdown()"
  >
    <span class="selector-icon">
      <img src="/images/lang-selector-icon.png" width="16px"/>
    </span>

    <span class="selector-label">
      {{ selected.label }}
    </span>

    <span class="selector-arrow">
      ▾
    </span>
  </button>

  <ul class="dropdown" *ngIf="isOpen">
    <li
      *ngFor="let lang of languages"
      (click)="selectLanguage(lang)"
      [class.active]="lang.code === selected.code"
    >
      {{ lang.label }}
    </li>
  </ul>
</div>
